// extracted by mini-css-extract-plugin
export default {"background":"RO","weightImage":"SO","drinkImage":"TO","content":"UO","rtbLeft":"VO","rtbRight":"WO","rtbLeftMobile":"XO","imageContainer":"YO","rtbBox":"ZO","line":"aP","rtbDesktop":"bP"};
    if(module.hot) {
      // 1743628927694
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  